var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isFormInit)?_c('div',[_c('page-result',{ref:"pageResult2",attrs:{"dataConfig":_vm.dataConfig}})],1):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }